// constants/palette.js
// Created: 2026-07-21
// Project: Giving Words to Voices
// Version: 1.0.0
//
// A single named home for the recurring CATEGORICAL / semantic colours that
// were being retyped as raw hex across the app (the review found #ef4444 used
// 381 times, #f59e0b 384). These are the scheme-INDEPENDENT reference hues — the
// fixed value a component reaches for when it needs "the danger red" or "the
// reviewer purple", instead of authoring a fresh hex at the call site.
//
// This is the HUE layer, and deliberately narrow:
//   • Theme-DEPENDENT surfaces (fills/borders that shift light↔dark) still come
//     from the active scheme + statusVariant() — they must stay next to their
//     isDarkMode conditionals, not here.
//   • Categorical identities already have homes: ROLE_COLORS, CLIP_CATEGORIES /
//     CLIP_STATUS_STYLE, SPEAKER_PALETTE. This file does not duplicate them.
//   • Genuinely one-off decorative colours stay inline on purpose.
//
// So: reach here for a recurring semantic/brand hue; leave a bespoke colour where
// it is. Each family gives the base plus the stronger/deeper/softer steps that
// actually recur in the codebase.

export const RED    = { soft: '#f87171', base: '#ef4444', strong: '#dc2626', deep: '#b91c1c' };
export const AMBER  = { soft: '#ff9f0a', base: '#f59e0b', strong: '#d97706', deep: '#b45309' };
export const GREEN  = { soft: '#86efac', base: '#22c55e', strong: '#16a34a', deep: '#15803d' };
export const BLUE   = { soft: '#93c5fd', base: '#3b82f6', strong: '#2563eb', deep: '#1d4ed8' };
export const PURPLE = { soft: '#a78bfa', base: '#8b5cf6', strong: '#7c3aed', deep: '#6d28d9' };
export const TEAL   = { base: '#0f766e' };
export const SLATE  = { light: '#cbd5e1', base: '#94a3b8', mid: '#64748b', gray: '#6b7280', muted: '#888888' };

// Brand / accent singletons that recur with a fixed meaning.
export const IOS_BLUE  = '#007aff';   // native-feeling primary action buttons
export const IOS_GREEN = '#34c759';
export const GOLD      = '#facc15';   // default / starred
export const INDIGO    = '#6366f1';
export const PINK      = '#ec4899';
export const SKY       = '#0ea5e9';

// Named semantic aliases — the meaning, not the hue. Prefer the scheme's
// theme.danger/success/etc. when a surface should follow the active theme;
// use these as the constant reference / fallback value.
export const DANGER  = RED.base;    // the delete convention (CLAUDE.md): always #ef4444
export const SUCCESS = GREEN.base;
export const WARNING = AMBER.base;
export const INFO    = BLUE.base;
